import React, { useState, useEffect } from "react";
import Link from "next/link";
import { useRouter, withRouter } from "next/router";
// import "./style.scss";
function Faculties({ faculties }) {
  const dataToBeFilter = [
    "Dr. Hadia Abdullah",
    "Salam Al-Marayati",
    "Edina Lekovic",
    "Brie Loskota",
  ];

  return (
    <div className="bayan-faculty faculty-mobile-view faculty-new-design">
      {/* {showAllFaculty && */}
      <div className="faculty">
        <div className="container">
          <div className="filter-btn">
            <Link href="/staff">
              <div className={`staff-btn common-btn`}>Staff</div>
            </Link>
            <div className={`fac-btn common-btn active`}>Faculty</div>
          </div>

          <h1 className="text-center headingF">Faculty</h1>
          <p className="text-center sub-headingF"></p>
          <div className="inner-faculty">
            {faculties
              ?.filter((val) => !dataToBeFilter.includes(val.name))
              ?.map((faculty, index) => {
                return (
                  <div className="sm-main" key={index}>
                    <div className="imgmm">
                      {/*<button className="imgmm" onClick={() => openAllDetail(faculty)}>*/}
                      <Link href={`/faculty/${faculty?.slug}`}>
                        <a>
                          <>
                            <img
                              src={`${process.env.CMS_API_ORIGIN}${faculty?.image.url}`}
                              alt={faculty?.full_name}
                            />
                            <div className="name">{faculty?.full_name}</div>
                            <p>{faculty?.title}</p>
                          </>
                        </a>
                      </Link>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {/*showDetail &&
					<div className="container">
						<div className="dr-new">
							<div className="left">
								<a onClick={() => closeAllDetail()} class="backbtn">Back</a>
								<img src={facultyDetail.image_url} alt={facultyDetail.name} />
								<h5>{facultyDetail.name}</h5>
							</div>

							<div className="right">
								<h2>{facultyDetail.name}</h2>
								<p>{facultyDetail.designation_long}</p>
								<p>{facultyDetail.bayan_designation}</p>
								{facultyDetail && facultyDetail.bayan_email && <p>Bayan Email: {facultyDetail.bayan_email}</p>}
								<div
								dangerouslySetInnerHTML={{ __html: facultyDetail.description }}
								></div>
							</div>
						</div>
					</div>
				*/}
    </div>
  );
}

export default withRouter(Faculties);
